import { NewsType } from "../../../../../networking/data/responses/news/NewsType";
import { NewsRaidElementsToDowngrade } from "../../../../common/models/latestnews/NewsRaidElementsToDowngrade";
import { GuestInfo } from "../diceActions/commonData/GuestInfo";
import { NewsDto } from "by/gamefactory/cityversetycoon/networking/data/responses/news/NewsDto";

export class NewsCard {
    public readonly type: NewsType;
    public readonly guest: GuestInfo;
    public readonly buildingWillBeDoungraded: Array<NewsRaidElementsToDowngrade>;
    public readonly afterClaim: boolean;

    public constructor(newsDto: NewsDto, afterClaim: boolean = false) {
        this.type = newsDto.type;
        this.guest = newsDto.guest != undefined ? new GuestInfo(newsDto.guest) : undefined;
        this.buildingWillBeDoungraded = newsDto.building?.downgradedElements.map(item => new NewsRaidElementsToDowngrade(item)) ?? [];
        this.afterClaim = afterClaim;
    }
}
